










































































import { Ota } from "@/shared/models/ota";
import { ReservationStatus } from "@/shared/models/reservationStatus";
import _ from "lodash";
import { Getter } from "vuex-class";
import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { ServerReservationCheckInCustomerData } from "../check-in/CheckinTypes";
import { ReservationModel } from "../types";
import CheckOutGuestCard from "./CheckOutGuestCard.vue";
import { Notification } from "@/store/modules/notifications";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";
import { EVisitorIntegrationNameEnum } from "@/shared/models/enums.type";

export type CheckedOutCustomersOnAccUnitType =
  ServerReservationCheckInCustomerData & {
    checked: boolean;
    unitDisplayFull: string;
    reservationAccUnitTypeId: number;
    isDayStay: boolean;
  };

@Component({ components: { CheckOutGuestCard } })
export default class CheckOutModalForm extends Vue {
  @PropSync("open", { default: false }) internalOpen?: boolean;

  @Prop() reservation?: ReservationModel;
  @Prop({ default: null }) singleUnit!: number | null;

  @Getter("appParams/checkOutOnEVisitorState")
  checkOutOnEVisitorState?: boolean;

  isLoading = false;

  internalValue: CheckedOutCustomersOnAccUnitType[] = [];
  @Prop() value?: CheckedOutCustomersOnAccUnitType[];
  @Watch("value", { immediate: true })
  valueChanged(fresh: CheckedOutCustomersOnAccUnitType[]) {
    this.eVisitorCheck = this.checkOutOnEVisitorState ?? false;
    this.isLoading = false;
    this.internalValue = fresh ? _.cloneDeep(fresh) : [];

    if (!this.internalValue.some((x) => !x.isDayStay)) {
      this.eVisitorCheck = false;
    }
  }

  @Watch("internalValue", { immediate: true, deep: true })
  internalValueChanged(){
    this.updateResStatus = !this.internalValue.some(e => !e.checked);
  }

  updateResStatus = false;
  eVisitorCheck = false;

  get all() {
    return (
      this.internalValue
        ?.filter((x) => x.isCheckedIn)
        .every((x) => x.checked) ?? false
    );
  }
  set all(val: boolean) {
    for (const x of this.internalValue.filter((x) => x.isCheckedIn)) {
      x.checked = val;
    }
  }

  @Ref("form") formRef?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  get updateStatusLabel() {
    if (this.singleUnit === null) {
      return this.$t("Update reservation status to checked-out");
    }
    return this.$t("Update unit status to checked-out");
  }

  async submit() {
    const valid = this.formRef?.validate();

    if (!valid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    this.isLoading = true;

    try {
      const nullEmpty = function (val: string | null) {
        const trimmed = val?.trim() ?? "";
        return trimmed === "" ? null : trimmed;
      };

      const copy = this.internalValue
        .filter((x) => x.checked)
        .filter((x) => x.isCheckedIn)
        .map((x) => ({
          id: x.id,
          reservationAccUnitTypeId: x.reservationAccUnitTypeId,
          eVisitorCheckoutDate: nullEmpty(x.eVisitorCheckoutDate),
          eVisitorCheckoutTime: nullEmpty(x.eVisitorCheckoutTime),
        }));

      const areStaysTypesMixed =
        this.internalValue.some((x) => x.isDayStay) &&
        this.internalValue.some((x) => !x.isDayStay);

      let copyForEVisitor = this.internalValue
        .filter((x) => x.checked)
        .filter((x) => x.isCheckedIn)
        .map((x) => ({
          id: x.id,
          isDayStay: x.isDayStay,
          reservationAccUnitTypeId: x.reservationAccUnitTypeId,
          eVisitorCheckoutDate: nullEmpty(x.eVisitorCheckoutDate),
          eVisitorCheckoutTime: nullEmpty(x.eVisitorCheckoutTime),
        }));

      if (areStaysTypesMixed) {
        copyForEVisitor = copyForEVisitor.filter((x) => !x.isDayStay);
      }

      const sendData = {
        reservationId: this.reservation?.id ?? 0,
        changeReservationStatusToCheckedOut: this.updateResStatus,
        payload: copy,
      };

      await this.axios.post(`reservations/CheckOutGuests`, sendData);

      try {
        if (this.eVisitorCheck) {
          if (areStaysTypesMixed) {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message: this.$t("EVisitor.DayStaysWillNotBeCheckedOut", {
                eVisitorServiceName: this.eVisitorIntegrationName,
              }),
              timeout: 30000,
              localize: false,
            } as Notification);
          }

          await this.axios.post(`reservations/CheckOutGuestsToEVisitor`, {
            reservationId: this.reservation?.id ?? 0,
            payload: copyForEVisitor,
          });
        }
      } catch {
        this.$emit("fail");
        return;
      }

      await Vue.axios.post(
        `reservations/ReservationUpdateForMultipleGuestIds`,
        { guestIds: copy.map((x) => x.id) }
      );

      this.$emit("saved");
      this.closeModal();
    } catch {
      // not in finally because the happy path is
      // reservation reloading and that's when this modal should close from parent
      // on new value set the flag will be reset
      // reset flag on error only:
      this.isLoading = false;
    }
  }

  closeModal() {
    this.internalOpen = false;
  }

  get reservationHolderName() {
    return this.reservation?.customer?.name ?? "";
  }

  @Getter("codebooks/otas") otas?: Ota[];
  get reservationOtaDisplay() {
    const tr = this.otas?.find((x) => x.id === this.reservation?.otaid)?.name;
    return tr ?? "";
  }

  @Getter("codebooks/reservationStatuses")
  reservationStatuses?: ReservationStatus[];
  get reservationStatusDisplay() {
    const tr = this.reservationStatuses?.find(
      (x) => x.id === this.reservation?.statusId
    )?.textResourceKey;
    return tr ? this.$t(tr) : "";
  }

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }
}
